import {faPaperclip} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {parseISO} from "date-fns";
import React from "react";
import {Link} from "react-router-dom";

import {ISample} from "./models";

import InlineCheckbox from "@toolbox/button-like/InlineCheckbox";
import Time from "@toolbox/design/Time";
import Highlighter from "@toolbox/display-blocks/Highlighter";

interface ISampleWithTimestampProps {
    sample: ISample;
    query: string;
    toggle(checked: boolean, id: string): void;
}

class SampleWithTimestamp extends React.PureComponent<ISampleWithTimestampProps> {
    public render() {
        const {sample, query, toggle} = this.props;
        const {hasAttachment, id, name, prefixName, selected, started, url} =
            sample;

        return (
            <React.Fragment>
                <InlineCheckbox
                    idSuffix={id}
                    className="mb-1"
                    checked={selected}
                    toggle={toggle}
                >
                    {prefixName && <span className="mr-1">{prefixName}</span>}
                    <Link to={url}>
                        <Highlighter query={query} text={name} />
                    </Link>
                    {hasAttachment && (
                        <FontAwesomeIcon
                            className="ml-2 text-muted"
                            icon={faPaperclip}
                        />
                    )}
                    <span className="text-muted ml-1">
                        <Time value={parseISO(started)} />
                    </span>
                </InlineCheckbox>
                <br />
            </React.Fragment>
        );
    }
}

export default SampleWithTimestamp;
